import React, { useState, useEffect } from 'react';
import './FAQ.css';
import { getFAQs } from '../services/communityService';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    getFAQs().then(setFaqs);
  }, []);

  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section fade-in">
      <h2 className="slide-left">FREQUENTLY ASKED QUESTIONS</h2>
      <div className="faq-container">
        {faqs.map((faq, i) => (
          <div key={i} className={`faq-box ${openIndex === i ? 'active' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(i)}>
              {faq.question}
              <span className="arrow">{openIndex === i ? '−' : '+'}</span>
            </div>
            <div className={`faq-answer${openIndex === i ? ' open' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
